module.exports = __webpack_public_path__ + "img/Etiqueta_PTI.72408d68.png";